module.exports = __webpack_public_path__ + "6f1ef7a000d9cb17a09cf52b97651e1d.png";